app.directive('dragNDrop', [function(){
    return {
        restrict: 'A',
        replace: false,
        transclude: false,
        scope: {

        },
        link: function(scope, element, attrs){
            element.on('dragenter', function(e){
                e.preventDefault();
                e.stopPropagation();
                element.addClass('over');
            });

            element.on('dragleave', function(e){
                e.preventDefault();
                e.stopPropagation();
                element.removeClass('over');
            });

            element.on('dragover', function(e){
                e.preventDefault();
                e.stopPropagation();
            });

            element.bind('drop', function(e){
                e.stopPropagation();
                e.preventDefault();
                element.removeClass('over');
                if(e.originalEvent.dataTransfer){
                    if(e.originalEvent.dataTransfer.files.length > 0){
                        var files = e.originalEvent.dataTransfer.files;
                        scope.$parent.$eval(attrs.onUpload, {
                            files: files
                        });
                    }
                }

                return false;
            });
        }
    };
}]);